import { render, staticRenderFns } from "./PatientCardIdent.vue?vue&type=template&id=67085c38&scoped=true&"
import script from "./PatientCardIdent.vue?vue&type=script&lang=js&"
export * from "./PatientCardIdent.vue?vue&type=script&lang=js&"
import style0 from "./PatientCardIdent.vue?vue&type=style&index=0&id=67085c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67085c38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VIcon,VLayout})
